import Vue from 'vue';
import VModal from 'vue-js-modal';
import App from './App.vue';
import router from './router';
import store from './store/store';
import '@/tracking';
import '@/helpers';
import '@/directives';

Vue.config.productionTip = false;
Vue.use(VModal);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
